<template>
  <div>
    <v-expansion-panels
      v-model="taskPanel"
      accordion
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="panel-header-color panel-selectable">
          <div
            :class="$vuetify.breakpoint.smAndDown ? 'subtitle-2' : 'subtitle-1'"
          >
            DXEより電子マニフェスト(EDI)に関するお知らせがあります
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row dense no-gutters>
            <v-col>
              <v-card flat light>
                <v-card-text class="pb-0">
                  <v-simple-table v-if="failureReports && failureReports.length > 0">
                    <template v-slot:default>
                      <tbody>
                      <tr
                        v-for="report in failureReports"
                        :key="report.report_type"
                      >
                        <td class="md10">
                          {{ listTitle(report.report_type) }}
                        </td>
                        <td class="md2 text-right">
                          <v-btn
                            color="primary"
                            text
                            @click="moveButtonClickEvent(report)"
                            class="font-weight-bold"
                            style="text-decoration: underline;"
                          >
                            {{ report.target_count }}件
                          </v-btn>
                        </td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <div v-else-if="failureReports && failureReports.length === 0" class="text-center">必要なお知らせはありません。</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  name: 'DashboardFailureReport',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      taskPanel: null,
      failureReports: null,
      attrs: {
        class: 'mb-6',
        boilerplate: true,
        elevation: 1,
      },
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      transportDay: 'transport_day',
      disposalDay: "disposal_day",
      finalDisposalDay: "final_disposal_day",
    }),
  },
  watch: {},
  created() {
    this.searchTenantTasks()
  },
  methods: {
    ...mapActions('DriverDashboardFailureReport', {
      fetchFailureReports: 'index',
    }),
    /**
     * 移動するボタン クリックイベント
     * @param item
     */
    moveButtonClickEvent(item) {
      let routeName = null;
      let condition = {};

      /*
      status: "ordered"
      manifest_type: "dxe_form"
       */
      // let today = new Date();
      // const yesterday = new Date(today.setDate(today.getDate() - 1));
      // const formattedDate = yesterday.toISOString().slice(0, 10);

      const yesterday = this.$dayjs().subtract(1, "day");
      const formattedDate = yesterday.format("YYYY-MM-DD");

      /*
        params: {id: item.original_id},
        query: {d: null}
       */

      if (item.report_type === 'none_register_order') {
        /*
         * 過去の日付で予約登録もしくは本登録がされていない受注データ
         * 受注一覧
         */
        routeName = 'DriverOrderAccepts'
        condition = {status: "ordered", manifest_type: "dxe_form", collected_end_date: formattedDate}

      } else {
        routeName = 'DriverManifestManagements'

        // today = new Date();
        // const transport_day = new Date(today.setDate(today.getDate() - this.transportDay));
        // const transportFormattedDate = transport_day.toISOString().slice(0, 10);
        //
        // today = new Date();
        // const disposal_day = new Date(today.setDate(today.getDate() - this.disposalDay));
        // const disposalFormattedDate = disposal_day.toISOString().slice(0, 10);
        //
        // today = new Date();
        // const final_disposal_day = new Date(today.setDate(today.getDate() - this.finalDisposalDay));
        // const finalDisposalFormattedDate = final_disposal_day.toISOString().slice(0, 10);

        const transport_day = this.$dayjs().subtract(this.transportDay, 'day')
        const transportFormattedDate = transport_day.format('YYYY-MM-DD')

        const disposal_day = this.$dayjs().subtract(this.disposalDay, 'day')
        const disposalFormattedDate = disposal_day.format('YYYY-MM-DD')

        const final_disposal_day = this.$dayjs().subtract(this.finalDisposalDay, 'day')
        const finalDisposalFormattedDate = final_disposal_day.format('YYYY-MM-DD')

        switch (item.report_type) {
          /*
           * 自社報告分で運搬報告がされていないマニフェストがあります。（区間１）
           * ・マニフェスト区分：電子マニフェスト（EDI）
           * ・運搬報告状況：自社未報告 ・運搬報告区間指定：第1区間
           * ・回収日(to)：システム日付 - マスタ運搬日数 以前
           * マニフェスト管理
           */
          case 'own_transport_not_reported_1':
            condition = { search_type: "detail", manifest_type: "dxe_form", transport_report_state: "self_unreported", end_date: transportFormattedDate, section_no: 1}
            break
          /*
           * 自社報告分で運搬報告がされていないマニフェストがあります。（区間２）
           * マニフェスト管理
           */
          case 'own_transport_not_reported_2':
            condition = { search_type: "detail", manifest_type: "dxe_form", transport_report_state: "self_unreported", end_date: transportFormattedDate, section_no: 2}
            break
          /*
           * 自社報告分で運搬報告がされていないマニフェストがあります。（区間３）
           * マニフェスト管理
           */
          case 'own_transport_not_reported_3':
            condition = { search_type: "detail", manifest_type: "dxe_form", transport_report_state: "self_unreported", end_date: transportFormattedDate, section_no: 3}
            break
          /*
           * 自社報告分で運搬報告がされていないマニフェストがあります。（区間４）
           * マニフェスト管理
           */
          case 'own_transport_not_reported_4':
            condition = { search_type: "detail", manifest_type: "dxe_form", transport_report_state: "self_unreported", end_date: transportFormattedDate, section_no: 4}
            break
          /*
           * 自社報告分で運搬報告がされていないマニフェストがあります。（区間５）
           * マニフェスト管理
           */
          case 'own_transport_not_reported_5':
            condition = { search_type: "detail", manifest_type: "dxe_form", transport_report_state: "self_unreported", end_date: transportFormattedDate, section_no: 5}
            break
          /*
           * 自社報告分で処分報告がされていないマニフェストがあります。
           * マニフェスト管理
           */
          case 'own_disposal_not_reported':

            condition = { search_type: "detail", manifest_type: "dxe_form", disposal_report_state: "self_unreported_jwnet", end_date: disposalFormattedDate}
            break
          /*
           * 自社報告分で最終処分報告がされていないマニフェストがあります。
           * マニフェスト管理
           */
          case 'last_disposal_not_reported':
            condition = { search_type: "detail", manifest_type: "dxe_form", final_report_state: "self_unreported_jwnet", end_date: finalDisposalFormattedDate}
            break
          /*
           * 運搬終了報告がJWNET期限切れ間近のマニフェストがあります。
           * マニフェスト管理
           */
          case 'deadline_near':
            condition = { search_type: "detail", manifest_type: "dxe_form", neared_status: "completion"}
            break
          /*
           * 運搬終了報告がJWNET期限切れのマニフェストがあります。
           * マニフェスト管理
           */
          case 'deadline':
            condition = { search_type: "detail", manifest_type: "dxe_form", expired_status: "completion"}
            break
          /*
          /*
           * 処分終了報告がJWNET期限切れ間近のマニフェストがあります。
           * マニフェスト管理
           */
          case 'disposal_deadline_near':
            condition = { search_type: "detail", manifest_type: "dxe_form", neared_status: "disposal"}
            break
          /*
           * 処分終了報告がJWNET期限切れのマニフェストがあります。
           * マニフェスト管理
           */
          case 'disposal_deadline':
            condition = { search_type: "detail", manifest_type: "dxe_form", expired_status: "disposal"}
            break
          /*
           * 最終処分終了報告がJWNET期限切れ間近のマニフェストがあります。
           * マニフェスト管理
           */
          case 'last_disposal_deadline_near':
            condition = { search_type: "detail", manifest_type: "dxe_form", neared_status: "report_final_disposal"}
            break
          /*
           * 最終処分終了報告がJWNET期限切れのマニフェストがあります。
           * マニフェスト管理
           */
          case 'last_disposal_deadline':
            condition = { search_type: "detail", manifest_type: "dxe_form", expired_status: "report_final_disposal"}
            break
          
          /*
           * 自社報告分で運搬報告がされていないマニフェスト（取込）があります。（区間１）
           * マニフェスト管理
           */
           case 'own_transport_not_reported_1_transfer':
            condition = { search_type: "detail", manifest_type: "transfer_form", transport_report_state: "self_unreported", end_date: transportFormattedDate, section_no: 1}
            break
          /*
           * 自社報告分で運搬報告がされていないマニフェスト（取込）があります。（区間２）
           * マニフェスト管理
           */
          case 'own_transport_not_reported_2_transfer':
            condition = { search_type: "detail", manifest_type: "transfer_form", transport_report_state: "self_unreported", end_date: transportFormattedDate, section_no: 2}
            break
          /*
           * 自社報告分で運搬報告がされていないマニフェスト（取込）があります。（区間３）
           * マニフェスト管理
           */
          case 'own_transport_not_reported_3_transfer':
            condition = { search_type: "detail", manifest_type: "transfer_form", transport_report_state: "self_unreported", end_date: transportFormattedDate, section_no: 3}
            break
          /*
           * 自社報告分で運搬報告がされていないマニフェスト（取込）があります。（区間４）
           * マニフェスト管理
           */
          case 'own_transport_not_reported_4_transfer':
            condition = { search_type: "detail", manifest_type: "transfer_form", transport_report_state: "self_unreported", end_date: transportFormattedDate, section_no: 4}
            break
          /*
           * 自社報告分で運搬報告がされていないマニフェスト（取込）があります。（区間５）
           * マニフェスト管理
           */
          case 'own_transport_not_reported_5_transfer':
            condition = { search_type: "detail", manifest_type: "transfer_form", transport_report_state: "self_unreported", end_date: transportFormattedDate, section_no: 5}
            break
          /*
           * 自社報告分で処分報告がされていないマニフェスト（取込）があります。
           * マニフェスト管理
           */
          case 'own_disposal_not_reported_transfer':
            condition = { search_type: "detail", manifest_type: "transfer_form", disposal_report_state: "self_unreported_jwnet", end_date: disposalFormattedDate}
            break
          /*
           * 自社報告分で最終処分報告がされていないマニフェスト（取込）があります。
           * マニフェスト管理
           */
          case 'last_disposal_not_reported_transfer':
            condition = { search_type: "detail", manifest_type: "transfer_form", final_report_state: "self_unreported_jwnet", end_date: finalDisposalFormattedDate}
            break
          /*
           * 運搬終了報告がJWNET期限切れ間近のマニフェスト（取込）があります。
           * マニフェスト管理
           */
          case 'deadline_near_transfer':
            condition = { search_type: "detail", manifest_type: "transfer_form", neared_status: "completion"}
            break
          /*
           * 運搬終了報告がJWNET期限切れのマニフェスト（取込）があります。
           * マニフェスト管理
           */
          case 'deadline_transfer':
            condition = { search_type: "detail", manifest_type: "transfer_form", expired_status: "completion"}
            break
          /*
           * 処分終了報告がJWNET期限切れ間近のマニフェスト（取込）があります。
           * マニフェスト管理
           */
          case 'disposal_deadline_near_transfer':
            condition = { search_type: "detail", manifest_type: "transfer_form", neared_status: "disposal"}
            break
          /*
           * 処分終了報告がJWNET期限切れのマニフェスト（取込）があります。
           * マニフェスト管理
           */
          case 'disposal_deadline_transfer':
            condition = { search_type: "detail", manifest_type: "transfer_form", expired_status: "disposal"}
            break
          /*
           * 最終処分終了報告がJWNET期限切れ間近のマニフェスト（取込）があります。
           * マニフェスト管理
           */
          case 'last_disposal_deadline_near_transfer':
            condition = { search_type: "detail", manifest_type: "transfer_form", neared_status: "report_final_disposal"}
            break
          /*
           * 最終処分終了報告がJWNET期限切れのマニフェスト（取込）があります。
           * マニフェスト管理
           */
          case 'last_disposal_deadline_transfer':
            condition = { search_type: "detail", manifest_type: "transfer_form", expired_status: "report_final_disposal"}
            break
        }

      }
      this.$router.push({ name: routeName, params: condition, query: {d: null} }, () =>{})
    },
    listTitle (report_type) {
      switch (report_type) {
        case 'none_register_order':
          return '過去の日付で予約登録もしくは本登録がされていない受注データがあります。'
        case 'own_transport_not_reported_1':
          return '自社報告分で運搬報告がされていないマニフェスト（EDI）があります。（区間１）'
        case 'own_transport_not_reported_2':
          return '自社報告分で運搬報告がされていないマニフェスト（EDI）があります。（区間２）'
        case 'own_transport_not_reported_3':
          return '自社報告分で運搬報告がされていないマニフェスト（EDI）があります。（区間３）'
        case 'own_transport_not_reported_4':
          return '自社報告分で運搬報告がされていないマニフェスト（EDI）があります。（区間４）'
        case 'own_transport_not_reported_5':
          return '自社報告分で運搬報告がされていないマニフェスト（EDI）があります。（区間５）'
        case 'own_disposal_not_reported':
          return '自社報告分で処分報告がされていないマニフェスト（EDI）があります。'
        case 'last_disposal_not_reported':
          return '自社報告分で最終処分報告がされていないマニフェスト（EDI）があります。'
        case 'deadline_near':
          return '運搬終了報告がJWNET期限切れ間近のマニフェスト（EDI）があります。'
        case 'deadline':
          return '運搬終了報告がJWNET期限切れのマニフェスト（EDI）があります。'
        case 'disposal_deadline_near':
          return '処分終了報告がJWNET期限切れ間近のマニフェスト（EDI）があります。'
        case 'disposal_deadline':
          return '処分終了報告がJWNET期限切れのマニフェスト（EDI）があります。'
        case 'last_disposal_deadline_near':
          return '最終処分終了報告がJWNET期限切れ間近のマニフェスト（EDI）があります。'
        case 'last_disposal_deadline':
          return '最終処分終了報告がJWNET期限切れのマニフェスト（EDI）があります。'

        case 'own_transport_not_reported_1_transfer':
          return '自社報告分で運搬報告がされていないマニフェスト（取込）があります。（区間１）'
        case 'own_transport_not_reported_2_transfer':
          return '自社報告分で運搬報告がされていないマニフェスト（取込）があります。（区間２）'
        case 'own_transport_not_reported_3_transfer':
          return '自社報告分で運搬報告がされていないマニフェスト（取込）があります。（区間３）'
        case 'own_transport_not_reported_4_transfer':
          return '自社報告分で運搬報告がされていないマニフェスト（取込）があります。（区間４）'
        case 'own_transport_not_reported_5_transfer':
          return '自社報告分で運搬報告がされていないマニフェスト（取込）があります。（区間５）'
        case 'own_disposal_not_reported_transfer':
          return '自社報告分で処分報告がされていないマニフェスト（取込）があります。'
        case 'last_disposal_not_reported_transfer':
          return '自社報告分で最終処分報告がされていないマニフェスト（取込）があります。'
        case 'deadline_near_transfer':
          return '運搬終了報告がJWNET期限切れ間近のマニフェスト（取込）があります。'
        case 'deadline_transfer':
          return '運搬終了報告がJWNET期限切れのマニフェスト（取込）があります。'
        case 'disposal_deadline_near_transfer':
          return '処分終了報告がJWNET期限切れ間近のマニフェスト（取込）があります。'
        case 'disposal_deadline_transfer':
          return '処分終了報告がJWNET期限切れのマニフェスト（取込）があります。'
        case 'last_disposal_deadline_near_transfer':
          return '最終処分終了報告がJWNET期限切れ間近のマニフェスト（取込）があります。'
        case 'last_disposal_deadline_transfer':
          return '最終処分終了報告がJWNET期限切れのマニフェスト（取込）があります。'

      }
    },
    searchTenantTasks () {
      this.fetchFailureReports().then((content) => {
        this.failureReports = [];
        if (content.failure_reports.length > 0) {
          this.failureReports = content.failure_reports.filter((report) => report.target_count > 0)
        }
        this.taskPanel = 0;
      })
    },
  }
}
</script>

<style scoped lang="scss">

</style>
